import { Lenguage } from './lenguage.enum';

export class FormatUtils {
    public static padLeftZero(num: number, size: number): string {
        let s = num + '';
        while (s.length < size) { s = '0' + s; }
        return s;
    }

    public static getLenguageDatapicker(lenguage: Lenguage) {
        let lenguageDatapicker;
        // debugger;
        /*if (lenguage === Lenguage.Spanish) {
            lenguageDatapicker = {
                firstDayOfWeek: 1,
                dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
                dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
                dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
                monthNames: [
                    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio',
                    'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
                ],
                monthNamesShort: [
                    'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
                    'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
                ],
                today: 'Hoy',
                clear: 'Borrar'
            };
        }
        return lenguageDatapicker;*/
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/_utils/services/formatUtils.ts